var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "p-0 m-0", staticStyle: { display: "inline-flex" } },
    [
      !!_vm.url
        ? _c(
            "b-col",
            { staticClass: "p-0 m-0" },
            [
              !!_vm.url
                ? _c(
                    "b-row",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.left",
                          modifiers: { hover: true, left: true },
                        },
                      ],
                      attrs: { title: _vm.tooltip },
                    },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-overlay",
                            {
                              attrs: {
                                show: _vm.consultando,
                                rounded: "sm",
                                "spinner-small": "",
                              },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: _vm.buttonVariant,
                                    disabled: _vm.consultando,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.verPdf()
                                    },
                                  },
                                },
                                [
                                  !_vm.consultando
                                    ? _c("b-icon", {
                                        attrs: {
                                          icon: _vm.icon,
                                          variant: _vm.iconVariant,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.consultando
                                    ? _c("b-icon", {
                                        attrs: {
                                          icon: _vm.iconing,
                                          variant: _vm.iconVariant,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !!_vm.texto
                                    ? _c("span", {
                                        domProps: {
                                          textContent: _vm._s(_vm.texto),
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: { name: "modal-pdfs", size: "xl" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "modal-title",
                                fn: function () {
                                  return [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "apeironGwApp.pdfsSolicitudPosgrado.pdfsSolicitud"
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "modal-footer",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "mt-3",
                                        attrs: { variant: "secondary" },
                                        on: {
                                          click: function ($event) {
                                            _vm.mostrarPdf = false
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.pdfsSolicitudPosgrado.acciones.cerrar"
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1174345705
                          ),
                          model: {
                            value: _vm.mostrarPdf,
                            callback: function ($$v) {
                              _vm.mostrarPdf = $$v
                            },
                            expression: "mostrarPdf",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "b-link",
                                    {
                                      attrs: {
                                        href: _vm.url,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(_vm.url),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c("embed", {
                                  attrs: {
                                    src: _vm.contenidoBase64,
                                    type: "application/pdf",
                                    width: "100%",
                                    height: "600",
                                    frameborder: "0",
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }